/**
 * Класс для .head если активен поиск
 * @type {string}
 */
const activeSearch = 'active active--search';

/**
 * Класс для .head если активно мобильное меню
 * @type {string}
 */
const activeNav = 'active active--nav';

const searchToggleClass = '.head-search__toggle';

const $html = $(document.documentElement);
const $head = $('.head');
const $inputSearch = $head.find('.head-search__query');
const $btnCloseSearch = $head.find('.js-btn-close-search');

$(document)
    .on('click', searchToggleClass, onClickSearchToggle)
    .on('click', '.head__nav-toggle', onClickNavToggle);

$btnCloseSearch.on('click', () => {
    disableSearch();
});

if ($head.find(searchToggleClass).hasClass('head-search__toggle--media-page')) {
    $(document).off('click', searchToggleClass, onClickSearchToggle);

    $(document).on('click', searchToggleClass, onClickSearchToggleInMediaPage);
}

/**
 * На странице медиа поиск, на экранах <= 1200, отображается постоянно
 * @param {MouseEvent} evt
 */
function onClickSearchToggleInMediaPage(evt) {
    const isAtTable = matchMedia('(min-width: 1200px)');

    if (isAtTable.matches) return;

    onClickSearchToggle(evt);
}

/**
 * Если поиск не активирован, то первый клик по submit-кнопке только активирует поиск, и лишь второй клик отправляет форму
 * @param {MouseEvent} evt
 */
function onClickSearchToggle(evt) {
    // submit поиска
    if (isSearchActive()) {
        return;
    }
    // активация поиска
    else {
        enableSearch();
        evt.preventDefault();
    }
}

/**
 *
 * @param {MouseEvent} evt
 */
function onClickNavToggle(evt) {
    if (isActive()) {
        disableHead();
        $('body').removeClass('menuOpen');
        $('.mobile-nav-list__link').removeClass('hidden-link'); // fix links visibility when inner menu is open;
    } else {
        enableNav();
        $('body').addClass('menuOpen');
    }

    evt.preventDefault();
}

function enableSearch() {
    disableNav();

    $head.addClass(activeSearch);

    $inputSearch.focus();

    $btnCloseSearch.addClass('show');
}

function enableNav() {
    disableSearch();

    $head.addClass(activeNav);
    $html.addClass('no-scroll');

    //NLMK.disableScroll($head[0]);
}

function disableSearch() {
    $head.removeClass(activeSearch);
    $btnCloseSearch.removeClass('show');
}

function disableNav() {
    $head.removeClass(activeNav);
    $html.removeClass('no-scroll');

    $(window).trigger(NLMK.events.DISABLED_MOBILE_NAVIGATION);

    //NLMK.enableScroll($head[0]);
}

function disableHead() {
    disableNav();
    disableSearch();
}

function isActive() {
    return isNavActive() || isSearchActive();
}

function isNavActive() {
    return $head.hasClass(activeNav);
}

function isSearchActive() {
    return $head.hasClass(activeSearch);
}

export { onClickNavToggle };



// WEBPACK FOOTER //
// ./js/main/module/head/head.js